export enum ERace {
  WHITE = 'White',
  BLACK = 'Black or African American',
  ASIAN = 'Asian',
  NATIVE = 'American Indian/Alaskan Native',
  ISLANDER = 'Hawaiian or other Pacific Islander',
  MULTI = 'Multi-Racial',
  DECLINE = 'Decline to Respond'
}
